import { PNL_VERSION_PAGE_SIZE } from 'src/components/star-grid/starGridConstants';
import { PnlDataVersion } from 'src/components/star-grid/reportSelectors.types';
import { isIcebergVersion, versionCatalogKey } from 'src/components/star-grid/utils/versionAvailability';

type FetchVersionPage = (offset: number) => Promise<readonly PnlDataVersion[]>;

const fetchPageOrKeepHistory = async (fetchPage: FetchVersionPage, offset: number, onIncomplete?: () => void): Promise<readonly PnlDataVersion[]> => {
  try {
    return await fetchPage(offset);
  } catch (error) {
    if (!offset) throw error;
    onIncomplete?.();
    return [];
  }
};

export const loadPnlVersions = async (fetchPage: FetchVersionPage, onIncomplete?: () => void): Promise<PnlDataVersion[]> => {
  const versions = new Map<string, PnlDataVersion>();
  for (let offset = 0; ; offset += PNL_VERSION_PAGE_SIZE) {
    const page = await fetchPageOrKeepHistory(fetchPage, offset, onIncomplete);
    const snapshots = page.filter(isIcebergVersion);
    const hasNewSnapshots = snapshots.some((version) => !versions.has(versionCatalogKey(version)));
    page.forEach((version) => versions.set(versionCatalogKey(version), version));
    if (page.some((version) => version.iceberg_error)) onIncomplete?.();
    if (snapshots.length < PNL_VERSION_PAGE_SIZE) break;
    // Older APIs ignore offset. Keep the loaded history, but never claim it is complete.
    if (!hasNewSnapshots) {
      onIncomplete?.();
      break;
    }
  }
  return [...versions.values()];
};
